import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { ContactComponent } from './pages/contact/contact.component';
import { QuoteComponent } from './pages/quote/quote.component';
import { SellPropertyComponent } from './pages/sell-property/sell-property.component';
import { LoginComponent } from './pages/login/login.component';
import { AdminComponent } from './pages/admin/admin.component';
import { ManagePropertiesComponent } from './pages/admin/manage-properties/manage-properties.component';
import { PropertyListingFormComponent } from './pages/admin/property-listing-form/property-listing-form.component';
import { AdminMessagesComponent } from './pages/admin/admin-messages/admin-messages.component';
import { AnalyticsComponent } from './pages/admin/analytics/analytics.component';
import { PropertiesComponent } from './pages/properties/properties.component';
import { PropertyDetailComponent } from './pages/property-detail/property-detail.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ServerErrorComponent } from './pages/server-error/server-error.component';
import { ForbiddenComponent } from './pages/forbidden/forbidden.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './pages/terms-of-service/terms-of-service.component';
import { adminGuard } from './guards/admin.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'quote', component: QuoteComponent },
  { path: 'sell-property', component: SellPropertyComponent },
  { path: 'login', component: LoginComponent },
  { path: 'properties', component: PropertiesComponent },
  { path: 'property/:id', component: PropertyDetailComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-of-service', component: TermsOfServiceComponent },
  { path: 'admin', component: AdminComponent, canActivate: [adminGuard] },
  { path: 'admin/messages', component: AdminMessagesComponent, canActivate: [adminGuard] },
  { path: 'admin/analytics', component: AnalyticsComponent, canActivate: [adminGuard] },
  { path: 'admin/manage-properties', component: ManagePropertiesComponent, canActivate: [adminGuard] },
  { path: 'admin/new-listing', component: PropertyListingFormComponent, canActivate: [adminGuard] },
  { path: 'admin/edit-property/:id', component: PropertyListingFormComponent, canActivate: [adminGuard] },
  
  // Error pages
  { path: '403', component: ForbiddenComponent },
  { path: '500', component: ServerErrorComponent },
  { path: '404', component: NotFoundComponent },
  { path: '**', component: NotFoundComponent } // Wildcard route for 404
];
